define('modules/layout/header',['require','jquery','underscore','evertrue','react','et_flux','components/elements/link'],function(require) {
  var $, EverTrue, Link, React, a, button, createComponent, div, i, li, span, ul, _, _ref;
  $ = require("jquery");
  _ = require("underscore");
  EverTrue = require("evertrue");
  React = require("react");
  createComponent = require("et_flux").createComponent;
  _ref = React.DOM, ul = _ref.ul, li = _ref.li, a = _ref.a, div = _ref.div, button = _ref.button, i = _ref.i, span = _ref.span;
  Link = require("components/elements/link");
  return createComponent("Header", {
    getInitialState: function() {
      return {
        nav_open: false
      };
    },
    doNavButtonActions: function() {
      this.$leftSideNav = $(".side-nav-left");
      return this.$leftSideNav.toggleClass("open");
    },
    toggleRightSideNav: function() {
      if (this.isMounted()) {
        this.setState({
          nav_open: !this.state.nav_open
        });
      }
      this.$rightSideNav = $(".side-nav-right");
      return this.$rightSideNav.toggleClass("open");
    },
    toggleBeacon: function() {
      return HS.beacon.open();
    },
    render: function() {
      var navArrowClass, organizationName, _ref1, _ref2;
      organizationName = ((_ref1 = EverTrue.Organization) != null ? _ref1.get("name") : void 0) || null;
      navArrowClass = this.state.nav_open ? "arrow-down" : "arrow-left";
      return div({
        className: "header"
      }, button({
        "data-type": "menu",
        type: "button",
        className: "nav-chrome btn-navbar menu",
        onClick: this.doNavButtonActions
      }, i({
        "aria-hidden": "true",
        className: "icon-reorder"
      })), a({
        href: "/",
        className: "logo-nav"
      }, div({
        className: "evertrue-title-img"
      })), span({
        className: "header-title"
      }, organizationName), ((_ref2 = EverTrue.User) != null ? _ref2.get("super_user") : void 0) ? ul({
        className: "org-picker nav"
      }, li(null, Link({
        className: "side-nav-toggle-right",
        onClick: this.toggleRightSideNav
      }, div({
        className: navArrowClass
      })))) : void 0, Link({
        className: "header-help",
        href: "https://evertrue.forumbee.com/",
        open_new_tab: true
      }, "Help"));
    }
  });
});

//# sourceMappingURL=header.js.map
;
